var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarRateWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7216 4.84408L14.1807 9.64822V9.87109H14.4307H18.8807C19.6062 9.87109 19.9089 10.7988 19.3149 11.228C19.3147 11.2281 19.3146 11.2283 19.3144 11.2284L15.6754 13.8277L15.5284 13.9326L15.5819 14.1052L17.0119 18.7152L17.012 18.7155C17.2291 19.4117 16.42 19.9749 15.8427 19.5326L15.8422 19.5322L12.1522 16.7222L12.001 16.6071L11.8496 16.7219L8.15957 19.5219L8.15864 19.5227C7.58143 19.9649 6.77228 19.4017 6.98936 18.7055L6.98947 18.7052L8.41947 14.0952L8.47298 13.9226L8.326 13.8177L4.686 11.2177L4.68527 11.2171C4.09551 10.7991 4.39259 9.86109 5.12069 9.86109H9.57069H9.75567L9.80976 9.6842L11.2898 4.8442L11.2898 4.8442L11.2905 4.84177C11.4988 4.1351 12.5022 4.12593 12.7215 4.84387C12.7215 4.84394 12.7216 4.84401 12.7216 4.84408Z",
    fill: "#FDF9F1",
    stroke: "#888785",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarRateWhite);
export default __webpack_public_path__ + "static/media/star_rate-white.2f8a06de8ed0bf866dea71c1801b8649.svg";
export { ForwardRef as ReactComponent };